import { useEffect } from "react";
import { syncLocalSessionsToRemote } from "../services/sessionSyncService";
import { syncWhispers } from "../services/whisperSync";
import { fetchUpdates } from "../services/updatesService";
import { useUpdates } from "./useUpdates";

export function useRetreatSync(userId: string | null) {
  useEffect(() => {
    if (!userId) return;
    void syncLocalSessionsToRemote(userId);
  }, [userId]);

  useEffect(() => {
    void syncWhispers();
    void fetchUpdates();
  }, []);

  return useUpdates();
}
